<mat-card appearance="raised">
  <ng-container *ngIf="user$ | async as context; else loading">
    <div mat-card-avatar>
      {{ context.username | slice:0:1}}
    </div>
    <mat-card-header>
      <mat-card-title>{{ context.username }}</mat-card-title>
    </mat-card-header>
  </ng-container>

  <mat-action-list>
    @for (viewAction of viewActions; track viewAction.actionName) {
      <button mat-list-item (click)="onViewActionClick(viewAction)">
        <mat-icon matListItemIcon>{{ viewAction.buildIcon() | translate }}</mat-icon>
        <span matListItemTitle>{{ viewAction.buildLabel() | translate }}</span>
      </button>
    }
  </mat-action-list>

  <mat-card-footer>
    <div class="version-text">{{ version }}</div>
  </mat-card-footer>
</mat-card>

<ng-template #loading>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</ng-template>
